enum RequestStatusEnum {
  all = 'all',
  validated = 'validated',
  needValidation = 'need-validation',
  spam = 'spam'
}

enum RequestTypeEnum {

    all = 'all',
    videocall = 'videocall',
    message = 'message',
    catalog = 'catalog',
    portalRequest = 'portal-request',      /*  request Type generica della pagina contacts / career */
    newsRequest = 'news-request',
    productRequest = 'product-request'
}

export { RequestTypeEnum, RequestStatusEnum };